import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseCellEditorComponent } from '../base_cell_editor.component';
import { BaseEnumPropertyViewModel } from '../../../../../src/lib/view-models/base-type/enum-property-view-model';
import { EnumTextBoxComponent } from '../../../../../src/lib/components/controls/core/enum-text-box/enum-text-box.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';
// create your cellEditor as a Angular component
@UntilDestroy()
@Component({
    selector: 'nts-enum-text-box-editor-cell',
    styleUrls: ['./enum-cell-editor.component.scss'],
    imports: [
        EnumTextBoxComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <nts-enum-text-box
            #textBox
            (valueChange)="valueChange($event)"
            (onFinishEditing)="onFinishEditing()"
            [style.width.px]="cellWidth"
            [showErrorTooltip]="false"
            [listenClickOutside]="true"
            [propertyViewModel]="enumPropertyViewModel"
            [showErrorBorder]="false"
            [modelUpdate]="false"
            appendTo="body">
        </nts-enum-text-box>
    `
})
export class EnumCellEditorComponent extends BaseCellEditorComponent<string | number> implements AfterViewInit {

    @ViewChild('textBox', { static: true }) set content(content: EnumTextBoxComponent) {
        this.textBox = content;
    }

    override textBox: EnumTextBoxComponent;

    get enumPropertyViewModel(): BaseEnumPropertyViewModel {
        return this.propertyViewModel as BaseEnumPropertyViewModel;
    }

    get cellWidth() {
        return this.params.eGridCell.clientWidth;
    }

    override ngAfterViewInit() {
        setTimeout(() => {
            setTimeout(() => {
                this.textBox.focus();
                this.textBox.show();
            });
        });

        this.gridContext.visibleRowsChange.pipe(untilDestroyed(this), take(1)).subscribe(() => {
            this.textBox.hide();
            this.onFinishEditing();
        });
    }

    override onKeyDown(event: KeyboardEvent) {
        const key = event.which || event.keyCode;
        if (key === 37 || key === 39) {
            // keyboard navigation
            // this.forcePropertyViewModelUpdate();
            event.stopPropagation();
            event.preventDefault();
            event.stopImmediatePropagation();
            this.navigateToNextCell(key);
        }
    }

    onFinishEditing() {
        this.params.stopEditing();
    }

    isPopup(): boolean {
        return false;
    }
}
